import React from 'react';
import { BottomSheet } from '../../../common/sharedComponents/BottomSheet';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { ButtonWrapper } from './styled.questionCard';
import { IStandardsBottomSheet } from 'src/app/@types/questionCard';
import { useTranslation } from 'react-i18next';

export function StandardsBottomSheet ({
  isBottomSheetOpen,
  handleOpenBottomsheet,
  handleViewPhoto,
  handleReplacePhoto,
  handleDeleteModal,
}: IStandardsBottomSheet) {
  const { t } = useTranslation();
  return (
    <BottomSheet isOpen={isBottomSheetOpen} onClose={handleOpenBottomsheet}>
      <ButtonWrapper>
        <ButtonBlockColumn>
          <ButtonLarge
            inverted={true}
            outlined={true}
            title={t('COMMON.MY_AUDIT.BUTTON.REPLACE')}
            onClick={() => handleReplacePhoto()}
          />
          <ButtonLarge
            inverted={true}
            outlined={true}
            title={t('COMMON.MY_AUDIT.BUTTON.VIEW')}
            onClick={() => handleViewPhoto()}
          />
          <ButtonLarge
            title={t('COMMON.MY_AUDIT.BUTTON.DELETE')}
            backgroundColor={'rustyRed'}
            onClick={handleDeleteModal}
          />
        </ButtonBlockColumn>
      </ButtonWrapper>
    </BottomSheet>
  );
}
